<form
	name="configure_delivery_form"
	class="form"
	[formGroup]="delivery_form"
	(submit)="onSubmit()"
	(input)="onFormInput($event)"
	novalidate
>
	<div class="heading">
		<h4>Choose your preferred delivery time...</h4>
	</div>
	<div class="row">
		<div class="col-xxs-30">
			<ui-date-picker-control
				[form]="delivery_form"
				[form_control]="delivery_form.controls['delivery_date']"
				[label]="'Preferred Delivery Date'"
				[unavailable_days]="unavailable_days"
				[unavailable_dates]="unavailable_dates"
				[start_date]="delivery_date_min"
				[min_date]="delivery_date_min"
			></ui-date-picker-control>
		</div>

		<div class="col-xxs-30">
			<ui-select-control
				[form]="delivery_form"
				[form_control]="delivery_form.controls['delivery_time']"
				[label]="'Preferred Delivery Time'"
				[options]="delivery_time_options"
				[empty_allowed]="false"
				[placeholder]="'Choose time of day...'"
			></ui-select-control>
		</div>
	</div>
	<div class="heading">
		<h4>Search for your address...</h4>
	</div>
	<div class="row">
		<div
			class="col-xxs-30 address-search"
			[class.has-addresses]="delivery_form.controls['search'].value && delivery_form.controls['search'].value.length > 3"
		>
			<ui-text-control
				[type]="'text'"
				[form]="delivery_form"
				[form_control]="delivery_form.controls['search']"
				[label]="'Address Search'"
				[placeholder]="'Start typing your address to search...'"
				[autocomplete]="false"
				(text_input)="onAddressSearch()"
			></ui-text-control>
			<a class="close-addresses" (click)="onCloseAddresses()"><i class="far fa-times"></i></a>
            <div *ngIf="addresses.length > 0" class="address-list">
                <ul>
                    <li *ngFor="let address of addresses">
                        <a (click)="onSelectAddress(address.id)">
                            <strong>{{ address.text }}</strong>  
                        </a>
                    </li>
                </ul>
            </div>
		</div>
	</div>
	<div class="heading">
		<h4>Or enter address manually...</h4>
	</div>
	<div class="row">
		<div class="col-xxs-30">
			<ui-text-control
				[type]="'text'"
				[form]="delivery_form"
				[form_control]="delivery_form.controls['line_1']"
				[label]="'Address Line 1'"
				[placeholder]="'Address line 1...'"
			></ui-text-control>
		</div>
		<div class="col-xxs-30">
			<ui-text-control
				[type]="'text'"
				[form]="delivery_form"
				[form_control]="delivery_form.controls['line_2']"
				[label]="'Address Line 2 (Optional)'"
				[placeholder]="'Address line 2...'"
			></ui-text-control>
		</div>
		<div class="col-xxs-30">
			<ui-text-control
				[type]="'text'"
				[form]="delivery_form"
				[form_control]="delivery_form.controls['line_3']"
				[label]="'Address Line 3 (Optional)'"
				[placeholder]="'Address line 3...'"
			></ui-text-control>
		</div>
		<div class="col-xxs-30">
			<ui-text-control
				[type]="'text'"
				[form]="delivery_form"
				[form_control]="delivery_form.controls['line_4']"
				[label]="'City (Optional)'"
				[placeholder]="'City...'"
			></ui-text-control>
		</div>
		<div class="col-xxs-30">
			<ui-text-control
				[type]="'text'"
				[form]="delivery_form"
				[form_control]="delivery_form.controls['postcode']"
				[label]="'Postcode'"
				[placeholder]="'Postcode...'"
			></ui-text-control>
		</div>

		<div class="col-xxs-30 submit-button-container">
			<button
				class="button positive-button block-button"
				[class.loading]="submitting"
				data-element-click="button__engage_configure_delivery_options[delivery]__positive-button[Submit Delivery Request]"
			>
				<span class="loading-spinner"></span>
				<span *ngIf="!submitting">Submit Delivery Request</span>
			</button>
		</div>
	</div>
</form>
